import { render } from "./ComingSoonView.vue?vue&type=template&id=1762c3e8"
import script from "./ComingSoonView.vue?vue&type=script&lang=js"
export * from "./ComingSoonView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__